<app-work-continuous-record
    #continuousRecordForm
    [folder]="store.folder()"
></app-work-continuous-record>
